<template>
    <div class="product-detail-page">
        <div class="desktop-page" v-if="!this.GLOBAL.isMobile">
            <div class="wrap" v-if="product">
                <section class="page-head">
                    <div class="tabs category-tabs">
                        <button
                            v-for="productType in productTypeList"
                            :key="productType.id"
                            type="button"
                            :class="{ active: isActiveType(productType.id) }"
                            @click="goProductType(productType.id)"
                        >
                            {{ productType.name }}
                        </button>
                    </div>
                </section>

                <section class="detail-main">
                    <div class="detail-media">
                        <div class="media-surface">
                            <PicZoom :url="cp + '/jyy/billFile/getFile?uuid=' + product.showPicUuid" :scale="2"></PicZoom>
                        </div>
                    </div>
                    <div class="detail-info">
                        <p v-if="currentTypeName" class="detail-kicker">{{ currentTypeName }}</p>
                        <h1 class="detail-title">{{ product.productName }} {{ product.productSpec }}</h1>
                        <p class="detail-subtitle">{{ product.showTitle }}</p>
                        <el-button
                            class="consult-button"
                            type="primary"
                            @click="$router.push({ path: '/item', query: { name: product.productName } })"
                        >
                            {{ $t('text3') }}
                        </el-button>
                    </div>
                </section>

                <section class="detail-section">
                    <div class="tabs detail-tabs">
                        <button type="button" :class="{ active: show_detail }" @click="tabLiClick(1)">{{ $t('text10') }}</button>
                        <button type="button" :class="{ active: show_file }" @click="tabLiClick(2)">{{ $t('text11') }}</button>
                    </div>
                    <div class="detail-body">
                        <div class="detail-content" v-if="show_detail">
                            <div class="editor-content-view" v-html="product.productIntroduction"></div>
                        </div>
                        <div class="detail-files" v-if="show_file">
                            <div v-for="file in product.billFiles || []" :key="file.uuid || file.billFileName" class="file-row">
                                <a target="_blank" class="file-name" :href="cp + '/jyy/billFile/getFile?uuid=' + file.uuid">
                                    {{ file.billFileName }}
                                </a>
                                <span class="file-time">{{ file.createTime }}</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="contact-strip">
                    <div class="contact-copy">
                        <h3>{{ $t('index_23') }}</h3>
                        <p>
                            {{ $t('index_24_1') }}<br>
                            {{ $t('index_25_1') }}<br>
                            {{ $t('index_27_1') }}
                            <a target="_blank" rel="noopener" href="https://www.amap.com/ssr/search?query=北京市昌平区沙河新飞达科技发展中心F6-3">
                                {{ $t('index_28_1') }}
                            </a>
                        </p>
                    </div>
                    <a href="#/item" class="more">{{ $t('text3') }}</a>
                </section>
            </div>
        </div>

        <div class="mobile-page" v-if="this.GLOBAL.isMobile">
            <div class="wrap" v-if="product">
                <section class="page-head mobile-head">
                    <div class="tabs category-tabs mobile-tabs">
                        <button
                            v-for="productType in productTypeList"
                            :key="productType.id"
                            type="button"
                            :class="{ active: isActiveType(productType.id) }"
                            @click="goProductType(productType.id)"
                        >
                            {{ productType.name }}
                        </button>
                    </div>
                </section>

                <section class="detail-main mobile-detail-main">
                    <div class="detail-media">
                        <div class="media-surface mobile-media-surface">
                            <img :src="cp + '/jyy/billFile/getFile?uuid=' + product.showPicUuid" :alt="product.productName">
                        </div>
                    </div>
                    <div class="detail-info mobile-detail-info">
                        <p v-if="currentTypeName" class="detail-kicker">{{ currentTypeName }}</p>
                        <h1 class="detail-title mobile-title">{{ product.productName }} {{ product.productSpec }}</h1>
                        <p class="detail-subtitle mobile-subtitle">{{ product.showTitle }}</p>
                        <el-button
                            class="consult-button"
                            type="primary"
                            @click="$router.push({ path: '/item', query: { name: product.productName } })"
                        >
                            {{ $t('text3') }}
                        </el-button>
                    </div>
                </section>

                <section class="detail-section">
                    <div class="tabs detail-tabs">
                        <button type="button" :class="{ active: show_detail }" @click="tabLiClick(1)">{{ $t('text10') }}</button>
                        <button type="button" :class="{ active: show_file }" @click="tabLiClick(2)">{{ $t('text11') }}</button>
                    </div>
                    <div class="detail-body">
                        <div class="detail-content" v-if="show_detail">
                            <div class="editor-content-view" v-html="product.productIntroduction"></div>
                        </div>
                        <div class="detail-files" v-if="show_file">
                            <div v-for="file in product.billFiles || []" :key="file.uuid || file.billFileName" class="file-row mobile-file-row">
                                <a target="_blank" class="file-name" :href="cp + '/jyy/billFile/getFile?uuid=' + file.uuid">
                                    {{ file.billFileName }}
                                </a>
                                <span class="file-time">{{ file.createTime }}</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="contact-strip mobile-contact">
                    <div class="contact-copy">
                        <h3>{{ $t('index_23') }}</h3>
                        <p>
                            {{ $t('index_24_1') }}<br>
                            {{ $t('index_25_1') }}<br>
                            {{ $t('index_27_1') }}
                            <a target="_blank" rel="noopener" href="https://www.amap.com/ssr/search?query=北京市昌平区沙河新飞达科技发展中心F6-3">
                                {{ $t('index_28_1') }}
                            </a>
                        </p>
                    </div>
                    <a href="#/item" class="more">{{ $t('text3') }}</a>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import {getParam} from '@/utils/utils'
import axios from '@/utils/axios'
import PicZoom from '@/components/PicZoom.vue'

export default {
    components: {PicZoom},
    data() {
        return {
            cp: this.GLOBAL.cp,
            goodsType: '',
            productTypeList: [],
            product: null,
            show_detail: true,
            show_file: false,
        }
    },
    computed: {
        currentTypeName() {
            const current = this.productTypeList.find(item => String(item.id || '') === String(this.goodsType || ''))
            return current ? current.name : ''
        },
    },
    mounted() {
        this.goodsType = getParam('type') || ''
        axios.get('/jyy/portal/getProductTypeList')
            .then(res => {
                this.productTypeList = res.data
            })
        axios.get('/jyy/portal/getProductDetail?id=' + getParam('id'))
            .then(res => {
                this.product = res.data.data
                this.goodsType = res.data.data.goodsType
            })
    },
    methods: {
        isActiveType(typeId) {
            return String(this.goodsType || '') === String(typeId || '')
        },
        goProductType(typeId) {
            this.$router.push({path: '/productList', query: {type: typeId}})
        },
        tabLiClick(type) {
            this.show_detail = type === 1
            this.show_file = type === 2
        },
    },
}
</script>

<style scoped>
.product-detail-page {
    min-height: 800px;
    background: linear-gradient(180deg, #f9fbff 0%, #f4f8fe 100%);
    color: #111c2d;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.wrap {
    width: min(1200px, calc(100% - 40px));
    margin: 0 auto;
}

.desktop-page {
    padding: 72px 0 64px;
}

.mobile-page {
    padding: 76px 0 44px;
}

.page-head {
    padding-bottom: 22px;
    border-bottom: 1px solid #dbe4ef;
}

.tabs {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0;
}

.tabs button {
    position: relative;
    min-height: 44px;
    padding: 0 24px 12px;
    border: none;
    border-radius: 0;
    background: transparent;
    color: #8a9ab0;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    transition: color 0.22s ease;
}

.tabs button::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 3px;
    background: linear-gradient(90deg, #09aeff 0%, #72f7b1 100%);
    transition: width 0.2s linear;
}

.tabs button:hover,
.tabs button.active {
    color: #0a3569;
    font-weight: 600;
}

.tabs button:hover::after,
.tabs button.active::after {
    width: 100%;
}

.detail-main {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 54px;
    align-items: center;
    padding: 40px 0 36px;
}

.media-surface {
    height: 460px;
    padding: 0;
    overflow: hidden;
}

.detail-kicker {
    margin: 0 0 12px;
    color: #1e4b86;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.04em;
}

.detail-title {
    margin: 0;
    font-size: clamp(30px, 2.2vw, 40px);
    line-height: 1.25;
    font-weight: 600;
    color: #111c2d;
}

.detail-subtitle {
    margin: 18px 0 28px;
    color: #5c6575;
    font-size: 16px;
    line-height: 1.9;
}

.consult-button,
.consult-button:hover,
.consult-button:focus {
    min-width: 144px;
    height: 42px;
    padding: 0 22px;
    border: 1px solid #184d93;
    border-radius: 8px;
    background: #184d93;
    color: #ffffff;
    box-shadow: none;
}

.detail-section {
    padding-top: 20px;
}

.detail-tabs {
    border-bottom: 1px solid #dbe4ef;
}

.detail-body {
    padding-top: 28px;
    min-height: 320px;
}

.detail-content ::v-deep .editor-content-view {
    color: #111c2d;
    line-height: 1.9;
    word-break: break-word;
}

.detail-content ::v-deep .editor-content-view img {
    max-width: 100%;
    height: auto;
}

.detail-content ::v-deep .editor-content-view table {
    display: block;
    max-width: 100%;
    overflow-x: auto;
}

.detail-files {
    border-top: 1px solid #eef3f9;
}

.file-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 18px 0;
    border-bottom: 1px solid #eef3f9;
}

.file-name {
    color: #111c2d;
    font-size: 16px;
    line-height: 1.7;
    text-decoration: none;
    word-break: break-all;
}

.file-time {
    flex-shrink: 0;
    color: #7d899b;
    font-size: 14px;
}

.contact-strip {
    margin-top: 42px;
    padding-top: 24px;
    border-top: 1px solid #dbe4ef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
}

.contact-copy h3 {
    margin: 0 0 10px;
    font-size: 20px;
    font-weight: 600;
    color: #111c2d;
}

.contact-copy p {
    margin: 0;
    color: #5c6575;
    font-size: 14px;
    line-height: 1.9;
}

.contact-copy a {
    color: #0a3569;
    text-decoration: none;
}

.more {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    padding: 0 22px;
    border-radius: 8px;
    border: 1px solid rgba(24, 77, 147, 0.25);
    color: #184d93;
    text-decoration: none;
    font-size: 15px;
    font-weight: 600;
    transition: all 0.22s ease;
    white-space: nowrap;
}

.more:hover {
    background: #184d93;
    border-color: #184d93;
    color: #ffffff;
}

.mobile-head {
    padding-bottom: 18px;
}

.mobile-tabs {
    justify-content: flex-start;
}

.mobile-detail-main {
    grid-template-columns: 1fr;
    gap: 26px;
    padding-top: 28px;
}

.mobile-media-surface {
    height: min(72vw, 360px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.mobile-media-surface img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.mobile-detail-info {
    padding-bottom: 8px;
}

.mobile-title {
    font-size: 26px;
}

.mobile-subtitle {
    font-size: 15px;
}

.mobile-file-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
}

.mobile-contact {
    align-items: flex-start;
    flex-direction: column;
}

@media (max-width: 1100px) {
    .detail-main {
        grid-template-columns: 1fr;
        gap: 28px;
    }

    .detail-info {
        max-width: 760px;
    }
}

@media (max-width: 640px) {
    .wrap {
        width: calc(100% - 24px);
    }

    .tabs button {
        padding: 0 16px 10px;
        font-size: 14px;
    }

    .media-surface {
        height: 320px;
    }

    .contact-strip {
        gap: 16px;
    }
}
</style>
